import React, { Suspense, useEffect, useState } from 'react'
import Announcement  from 'Announcement'
import { HashRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { Credentials, StringTranslations } from '@crowdin/crowdin-api-client'
import BigNumber from 'bignumber.js'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import MigrateV1 from './MigrateV1'
import ERC20_INTERFACE from '../constants/abis/erc20'
import { useTokenBalances } from '../state/wallet/hooks'
import {useSingleCallResult } from '../state/multicall/hooks'
import { useActiveWeb3React } from '../hooks/index'
import { useTokenContract,useTokenPolyJetClubProxys,useMasterchefContract,useMasterchefV0Contract,useMasterchefV1Contract,useTokenPolyJetClub,useRewardMappingContract,
  useMasterchefContractv4
} from '../hooks/useContract'
import MigrateV1Exchange from './MigrateV1/MigrateV1Exchange'
import RemoveV1Exchange from './MigrateV1/RemoveV1Exchange'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
// import Farm from './Farm'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'
import { EN, allLanguages } from '../constants/localisation/languageCodes'
import { LanguageContext } from '../hooks/LanguageContext'
import { TranslationsContext } from '../hooks/TranslationsContext'
import Menu from '../components/Menu'
import migrateAddress from "../constants/v2Farms/index"


export interface LangType {
  code: string
  language: string
}
const CACHE_KEY = 'pancakeSwapLanguage'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 56px 0px;
  min-height: calc(100vh - 152px);
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  background-image: url('/static/media/bg.bfd323f2.png');
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

export default function App() {
  const [selectedLanguage, setSelectedLanguage] = useState<any>(undefined)
  const [translatedLanguage, setTranslatedLanguage] = useState<any>(undefined)
  const [translations, setTranslations] = useState<Array<any>>([])

  const apiKey = `${process.env.REACT_APP_CROWDIN_APIKEY}`
  const projectId = parseInt(`${process.env.REACT_APP_CROWDIN_PROJECTID}`)
  const fileId = 6
  
  const credentials: Credentials = {
    token: apiKey
  }
  const stringTranslationsApi = new StringTranslations(credentials)
  const { account } = useActiveWeb3React()


  const {puAddress,pwAddress,wpscAddress,usdtAddress,wdcAddress,polyJetClubProProxy,masterchefv2,masterchefv4,masterchefv3,masterchefv0,masterchefv1,polyJetClub,pu_pid,pw_pid,RewardMappingContract } =  migrateAddress
  
 
  const recordMappingContract = useRewardMappingContract(RewardMappingContract)


  const masterchefV4Contract= useMasterchefContractv4(masterchefv4)

  

  const getbalance = async ()=>{
 
    if(account && masterchefV4Contract && recordMappingContract){
 

      const puUserInfo = await masterchefV4Contract.userInfo(pu_pid,account)
      const pwUserInfo = await masterchefV4Contract.userInfo(pw_pid,account)

      const record = await recordMappingContract.getInfo(account)
   
      const recordPU_c = new BigNumber(record.pid0._hex).toString()
      const recordPw_c = new BigNumber(record.pid1._hex).toString()
       
      if(
        (!puUserInfo.isMigrate &&  new BigNumber(recordPU_c).isGreaterThan(0))|| (!pwUserInfo.isMigrate && new BigNumber(recordPw_c).isGreaterThan(0))
      ){
         window.location.href="https://pool.polysmartchain.com/#/migration"
      }
    }
  }

  // getbalance()
   
  const getStoredLang = (storedLangCode: string) => {
    return allLanguages.filter(language => {
      return language.code === storedLangCode
    })[0]
  }

  useEffect(() => {
    const storedLangCode = localStorage.getItem('pancakeSwapLanguage')



    if (storedLangCode) {
      const storedLang = getStoredLang(storedLangCode)
      setSelectedLanguage(storedLang)

    } else {
      setSelectedLanguage(EN)
    }
  }, [])

  useEffect(() => {
    /*
    if (selectedLanguage) {
      console.log(selectedLanguage)
       // fetchTranslationsForSelectedLanguage()
      setTranslatedLanguage(selectedLanguage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage]) */
 
  

  


  if (selectedLanguage) {
     localStorage.setItem(CACHE_KEY, selectedLanguage.code)
      // console.log(`import(\`../../../public/i18n/${selectedLanguage.code}.json\`)`);
      fetch(`./locales/${selectedLanguage.code}.json`)
        .then((r) => r.json())
        // fetchTranslationsForSelectedLanguage(selectedLanguage)
        .then((translationApiResponse) => {
          // console.log(translationApiResponse.data)
          if (translationApiResponse.data.length < 1) {
            setTranslations(['error'])
          } else {
            setTranslations(translationApiResponse.data)
          }
        })
        .then(() => setTranslatedLanguage(selectedLanguage))
        .catch((e) => {
          console.error('ERROR')
          console.error(e)
          setTranslations(['error'])
        })
    }
  }, [selectedLanguage, setTranslations])

  const fetchTranslationsForSelectedLanguage = async () => {
    stringTranslationsApi
      .listLanguageTranslations(projectId, selectedLanguage.code, undefined, fileId, 200)
      .then(translationApiResponse => {
        if (translationApiResponse.data.length < 1) {
          setTranslations(['error'])
        } else {
          setTranslations(translationApiResponse.data)
        }
      })
      .then(() => setTranslatedLanguage(selectedLanguage))
      .catch(error => {
        setTranslations(['error'])
        console.error(error)
      })
  }
  
  /*
  const handleLanguageSelect = (langObject: LangType) => {
    setSelectedLanguage(langObject)
    localStorage.setItem(CACHE_KEY, langObject.code)
  }
  */




  return (
    <Suspense fallback={null}>
      <HashRouter>
        <AppWrapper>
          <LanguageContext.Provider
            value={{ selectedLanguage, setSelectedLanguage, translatedLanguage, setTranslatedLanguage }}
          >
            <TranslationsContext.Provider value={{ translations, setTranslations }}>
              <Menu>
                <BodyWrapper>
                  <Popups />
                  <Web3ReactManager>
                    <Switch>
                      <Route exact strict path='/swap' component={Swap} />
                      <Route exact strict path='/swap/:outputCurrency' component={RedirectToSwap} />
                      <Route exact strict path='/announcement' component={Announcement} />
                      <Route exact strict path='/send' component={RedirectPathToSwapOnly} />
                      <Route exact strict path='/find' component={PoolFinder} />
                      <Route exact strict path='/pool' component={Pool} />
                      <Route exact strict path='/create' component={RedirectToAddLiquidity} />
                      <Route exact path='/add' component={AddLiquidity} />
                      <Route exact path='/add/:currencyIdA' component={RedirectOldAddLiquidityPathStructure} />
                      <Route exact path='/add/:currencyIdA/:currencyIdB' component={RedirectDuplicateTokenIds} />
                      <Route exact strict path='/remove/v1/:address' component={RemoveV1Exchange} />
                      <Route exact strict path='/remove/:tokens' component={RedirectOldRemoveLiquidityPathStructure} />
                      <Route exact strict path='/remove/:currencyIdA/:currencyIdB' component={RemoveLiquidity} />
                      <Route exact strict path='/migrate/v1' component={MigrateV1} />
                      <Route exact strict path='/migrate/v1/:address' component={MigrateV1Exchange} />
                      <Route component={RedirectPathToSwapOnly} />
                    </Switch>
                  </Web3ReactManager>
                  
                  {/* <Marginer /> */}
                </BodyWrapper>
                
              </Menu>
            </TranslationsContext.Provider>
          </LanguageContext.Provider>
        </AppWrapper>
      </HashRouter>
    </Suspense>
  )
}
